export type CreateComponentProjectResponse = {};
